import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Table from '../../components/Table';
import SubHeader from '../../components/SubHeader';
import Pagination from '../../components/Pagination';
import { getAvailableVehicles } from '../../redux/available-vehicles';
import FiltersContainer from '../../components/Filter/FiltersContainer';
import Modal from '../../components/Modal';
import Map from '../../components/Map';
import Button from '../../components/Button';

import './styles.css';
import Totalizers from '../../components/Totalizers';
import ProgressBar from '../../components/ProgressBar';

const PAGINATION_OPTIONS = [{
  value: 10,
  label: '10',
}, {
  value: 30,
  label: '30',
}, {
  value: 50,
  label: '50',
}, {
  value: 100,
  label: '100',
}];

const SHIPPING_GROUPS = [
  {
    name: 'LUFT',
    id: 1,
  },
  {
    name: 'COMANDOLOG',
    id: 29819,
  },
  {
    name: 'IWEX',
    id: 23329,
  },
];

const OPERATION = [
  {
    name: 'EM OPERAÇÃO',
    id: 1,
  },
  {
    name: 'DISPONÍVEIS',
    id: 2,
  },
];

class Vehicles extends Component {
  state = {
    currentRecordsPerPage: 30,
    currentPage: 1,
    currentPlateFilter: '',
    currentShippingCompanyIdFilter: null,
    currentOperationFilter: 1,
    showMapModal: false,
    currentLatitude: -14.238962,
    currentLongitude: -51.913029,
    currentShippingCompanyId: null,
    currentTotalItems: 0,
    totalizers: null,
    progressBarState: 100,
    progressTime: 300000,
  }

  componentDidMount() {
    this._doFetch();
    this.fetchInterval = setInterval(this._doFetch, 300000);
    this.interval = this.controlProgressBar();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.fetchInterval);
  }

  controlProgressBar() {
    const interval = setInterval(() => {
      const { progressTime } = this.state;
      this.setState(prevState => ({
        progressBarState: progressTime === 0 ? 100 : prevState.progressBarState - 0.33,
        progressTime: progressTime === 0 ? 300000 : prevState.progressTime - 1000,
      }));
    }, 1000);
    return interval;
  }

  _renderFormattedCounter = () => {
    let counterMinutes = (moment.duration(this.state.progressTime).minutes()).toString();
    let counterSeconds = (moment.duration(this.state.progressTime).seconds()).toString();

    if (counterMinutes.length === 1) {
      counterMinutes = `0${counterMinutes}`;
    }

    if (counterSeconds.length === 1) {
      counterSeconds = `0${counterSeconds}`;
    }

    return `${counterMinutes}:${counterSeconds}`;
  }

  _openMap = (latitude, longitude, shippingCompaniesId) => this.setState({
    currentLatitude: latitude,
    currentLongitude: longitude,
    currentShippingCompanyId: shippingCompaniesId,
    showMapModal: true,
  })

  _doFetch = () => {
    const {
      currentPage,
      currentRecordsPerPage,
      currentPlateFilter,
      currentShippingCompanyIdFilter,
      currentOperationFilter,
    } = this.state;

    const params = {
      page: currentPage,
      amount: currentRecordsPerPage,
      plate: currentPlateFilter,
      companyGroupId: currentShippingCompanyIdFilter,
      operation: currentOperationFilter === 1,
    };

    this.props.getAvailableVehicles(params).then((data) => {
      if (data) {
        if (data.pagination) {
          this.setState({
            currentPage: data.pagination.currentPage > 0 ? data.pagination.currentPage : 1,
            currentTotalItems: data.pagination.totalRecords,
            totalizers: data.pagination.totalRecords,
          });
        }
      }
    });
  }

  _handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this._doFetch();
    });
  }

  _handlePageLimitChange = (pageLimit) => {
    this.setState({ currentRecordsPerPage: pageLimit }, () => {
      this._doFetch();
    });
  }

  _haveData() {
    if (this._getTableData().length > 0) {
      return true;
    }

    return false;
  }

  _onFilterByOperation = (operation) => {
    this.setState({ currentOperationFilter: operation.value, currentPage: 1 }, () => {
      this._doFetch();
    });
  }

  _onFilterByPlate = (plate) => {
    this.setState({ currentPlateFilter: plate, currentPage: 1 }, () => {
      this._doFetch();
    });
  }

  _onFilterByShippingCompanyId = (selected) => {
    this.setState({ currentShippingCompanyIdFilter: selected.value, currentPage: 1 }, () => {
      this._doFetch();
    });
  }

  _getTableData = () => {
    const {
      availableVehicles,
    } = this.props;

    if (!availableVehicles) {
      return [];
    }

    return availableVehicles.map(line => ({
      plate: line.plate,
      type: line.type,
      trackerId: line.trackerId,
      brand: line.brand,
      model: line.model,
      companyGroupName: line.companyGroupName,
      location: <Button className="AvailableVehicles__Button" disabled={(!line.latitude || !line.longitude)} size="small" type="button" skin="primary" text="Localização" onClick={() => this._openMap(line.latitude, line.longitude, line.companyGroupId)} />,
    }));
  }

  render() {
    const {
      currentPage,
      currentRecordsPerPage,
      currentPlateFilter,
      currentShippingCompanyIdFilter,
      currentOperationFilter,
      showMapModal,
      currentLatitude,
      currentLongitude,
      currentShippingCompanyId,
      currentTotalItems,
      totalizers,
      progressBarState,
    } = this.state;
    const {
      isFetching,
    } = this.props;
    return (
      <div className="AvailableVehicles__root">
        <div className="AvailableVehicles__header-container">
          <SubHeader
            title="Veículos"
          />
          {totalizers && <Totalizers
            title="Em trânsito"
            totalizers={totalizers}
          />}
          <div className="AvailableVehicles__FiltersContainer">
            <FiltersContainer
              filters={[
                {
                  identifier: 'plate',
                  label: 'PLACA',
                  type: 'text',
                  onFilter: this._onFilterByPlate,
                  placeholder: 'Informe a placa',
                  currentValue: currentPlateFilter,
                },
                {
                  identifier: 'company',
                  label: 'EMPRESA',
                  type: 'select',
                  currentValue: currentShippingCompanyIdFilter,
                  placeholder: 'Selecione uma opção',
                  enumerator: SHIPPING_GROUPS,
                  options: [
                    {
                      label: 'LUFT',
                      value: 1,
                    },
                    {
                      label: 'COMANDOLOG',
                      value: 29819,
                    },
                    {
                      label: 'IWEX',
                      value: 23329,
                    },
                  ],
                  onFilter: this._onFilterByShippingCompanyId,
                },
                {
                  identifier: 'operation',
                  label: 'STATUS',
                  type: 'select',
                  currentValue: currentOperationFilter,
                  placeholder: 'Selecione uma opção',
                  enumerator: OPERATION,
                  options: [
                    {
                      label: 'EM OPERAÇÃO',
                      value: 1,
                    },
                    {
                      label: 'DISPONÍVEIS',
                      value: 2,
                    },
                  ],
                  onFilter: this._onFilterByOperation,
                },
              ]}
            />
          </div>
        </div>
        <div
          style={{
              marginTop: 16, marginRight: 16, marginLeft: 16,
          }}
        >
          <div>
            Próxima atualização em: {this._renderFormattedCounter()}
          </div>
          <ProgressBar
            completed={progressBarState}
            style={{
              width: 'auto',
            }}
          />
        </div>
        <Table
          className="AvailableVehicles__table"
          isFetching={isFetching}
          headers={[
            {
              title: 'Placa',
            },
            {
              title: 'Tipo',
            },
            {
              title: 'N° Rastreador',
            },
            {
              title: 'Marca',
            },
            {
              title: 'Modelo',
            },
            {
              title: 'Empresa',
            },
            {
              title: 'Localização',
            },
          ]}
          data={this._getTableData()}
        />
        {!isFetching && this._haveData() && <Pagination
          options={PAGINATION_OPTIONS}
          currentPage={currentPage}
          pageLimit={currentRecordsPerPage}
          totalItems={currentTotalItems}
          onChangePage={this._handlePageChange}
          onPageLimitChange={this._handlePageLimitChange}
        />}
        {showMapModal &&
          <Modal
            title="Localização atual"
            onBackdropClick={() => this.setState({ showMapModal: false })}
          >
            <Map
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNV7mHyjuTm0VC8ZZnW90OTZWrvBnXIaw&v=3.exp&libraries=geometry,drawing,places"
              loadingElement={<div className="AvailableVehicles__loading-el" />}
              latitude={currentLatitude}
              longitude={currentLongitude}
              containerElement={<div className="AvailableVehicles__container-el" />}
              mapElement={<div className="AvailableVehicles__map-el" />}
              isKeyAccount={false}
              shippingGroupId={currentShippingCompanyId}
              performanceStatusCode={1}
            />
          </Modal>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.availableVehicles.isFetching,
  availableVehicles: state.availableVehicles.list,
});

const mapActionsToProps = {
  getAvailableVehicles,
};

export default connect(mapStateToProps, mapActionsToProps)(Vehicles);
